import { graphql } from '../../../gql';

// TRIL-332: fired once when the post detail opens. Server dedups per viewer, so
// re-opens/refreshes don't inflate reachCount; returns counted=false for
// anonymous / author-self / already-read.
export const RECORD_POST_READ_MUTATION = graphql(`
  mutation RecordPostRead($input: RecordReadInput!) {
    recordPostRead(input: $input) { postId reachCount counted }
  }
`);
